export const INITIALIZE_FILTERS = 'filters/INITIALIZE_FILTERS'
export const SET_FILTERS_CONFIGURATION = 'filters/SET_FILTERS_CONFIGURATION'
export const COMMIT_FILTERS_CONFIGURATION = 'filters/COMMIT_FILTERS_CONFIGURATION'
export const SET_FILTERS_ERROR = 'filters/SET_FILTERS_ERROR'
export const SET_LOADING = 'filters/SET_LOADING'
export const SET_BLOCKING = 'filters/SET_BLOCKING'
export const SET_CURRENT_OPENED_FILTER_MODAL = 'filters/SET_CURRENT_OPENED_FILTER_MODAL'
export const SET_LAST_DATA_PATH_ENCODED = 'filters/SET_LAST_DATA_PATH_ENCODED'
export const REVERT_FILTERS_CONFIGURATION = 'filters/REVERT_FILTERS_CONFIGURATION'
export const OPEN_CANCELLATION_POLICY_MODAL = 'filters/OPEN_CANCELLATION_POLICY_MODAL'
export const CLOSE_CANCELLATION_POLICY_MODAL = 'filters/CLOSE_CANCELLATION_POLICY_MODAL'
